function FinanceTable({
  balance,
  omsætningIaltEntireLastYearAmount,
  processedLastYearBalanceData,
}) {
  const options = { maximumFractionDigits: 2 };
  const boldStyle = { fontWeight: "bold" };
  const regularStyle = { fontWeight: "normal" };
  const amount = balance.periods ? balance.periods[0].amount : balance.amount;
  const formattedAmount = Intl.NumberFormat('dk-DK', options).format(-amount) + ' kr';
  const balancePercentage = !isNaN(balance.percentage) ? `${Math.abs(balance.percentage)} %` : "";
  let lastYearPercentage = "";
  if (processedLastYearBalanceData && balance.accountNumber !== 1995) {
    const lastYearBalance = processedLastYearBalanceData.find(item => item.accountNumber === balance.accountNumber);
    if (lastYearBalance) {
      const lastYearAmount = lastYearBalance.amount || (lastYearBalance.periods && lastYearBalance.periods[0].amount);
      lastYearPercentage = !isNaN(lastYearAmount) ? ((lastYearAmount / omsætningIaltEntireLastYearAmount) * 100).toFixed(2) + ' %' : "";
    }
  }
  // if (isLastYearBalanceDataLoading || isBalanceLoading || isBudgetLoading) {
  //   return <LoadingComponent></LoadingComponent>;
  // }
  // if (isLastYearBalanceDataError || isBalanceError || isBudgetError) {
  //   return <div>Error...</div>;
  // }
  return (
    <div className="row" key={balance.accountNumber}>
      <div style={balance.accountName === 'Omsætning i alt' ? boldStyle : regularStyle} className="col-2 bg-light border-bottom border-start border-dark p-1">
        {balance.accountName}
      </div>
      <div className="col-2 bg-light border-start border-bottom border-dark p-1">
        {formattedAmount}
      </div>
      <div className="col-1 bg-light border-start border-bottom border-dark p-1">
        {balancePercentage}
      </div>
      <div className="col-1 bg-light border-start border-end border-bottom border-dark p-1">
        {lastYearPercentage}
      </div>
    </div>
  );
}

export default FinanceTable;

